(function () {
const $a6f082bb96fcbb30$var$refs = {
    burgerIcon: document.querySelector(".burger-icon"),
    closeIcon: document.querySelector(".icon-x"),
    modalmenu: document.querySelector(".modal-menu"),
    body: document.querySelector("body")
};
$a6f082bb96fcbb30$var$refs.burgerIcon.addEventListener("click", ()=>{
    $a6f082bb96fcbb30$var$refs.modalmenu.classList.remove("is-hidden");
    $a6f082bb96fcbb30$var$refs.body.style.overflow = "hidden";
});
$a6f082bb96fcbb30$var$refs.closeIcon.addEventListener("click", ()=>{
    $a6f082bb96fcbb30$var$refs.modalmenu.classList.add("is-hidden");
    $a6f082bb96fcbb30$var$refs.body.style.overflow = "scroll";
});



})();
//# sourceMappingURL=about.477c1884.js.map
